import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import Register from '../components/Register.vue';
import Login from '../components/Login.vue';
import Dashboard from '@/components/dashboard/Dashboard.vue';
import Orders from '@/components/orders/Orders.vue';
import Drivers from '@/components/drivers/Drivers.vue';
import Passengers from '@/components/passengers/Passengers.vue';
import Companies from '@/components/companies/Companies.vue';
import Settings from '@/components/settings/Settings.vue';
import Dispatcher from '@/components/dispatchers/Dispatcher.vue'
import Login2FA from '@/components/Login2FA.vue';
import CompanyProfile from '@/components/profile/CompanyProfile.vue';
import OrderProfile from '@/components/profile/OrderProfile.vue';
import DriverProfile from '@/components/profile/DriverProfile.vue';
import PassengerProfile from '@/components/profile/PassengerProfile.vue';
import DispatcherProfile from '@/components/profile/DispatcherProfile.vue';
import OrderArchive from '@/components/orderArchive/orderArchive.vue';
import Station from '@/components/stations/Station.vue';
import DashboardDriver from '@/components/dashboard/DashboardDriver.vue';
import Payoff from '@/components/payoff/Payoff.vue';
import PayoffProfile from '@/components/profile/PayoffProfile.vue';
import PayoffCompany from '@/components/payoff/PayoffCompany.vue';
import OrderProfileCompany from '@/components/profile/OrderProfileCompany.vue';
import PayoffDriver from '@/components/payoff/PayoffDriver.vue';
import Invoices from '@/components/invoices/Invoices.vue';
import ChatDriver from '@/components/chat/ChatDriver.vue';
import CompanyArchive from '@/components/companies/CompanyArchive.vue';
import DriverArchive from '@/components/drivers/DriverArchive.vue';
import Hotel from '@/components/hotels/Hotel.vue';

const routes = [
  { path: '/register', name: 'RegisterPage', component: Register, }, //To mozna wywalić
  { path: '/login', name: 'LoginPage', component: Login, },
  { path: '/login/2fa', name: 'Login2FA', component: Login2FA }, //To mozna wywalić

  { path: '/admin/dashboard', name: 'DashboardPageAdmin', component: Dashboard, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/orders', name: 'OrdersPageAdmin', component: Orders, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/drivers', name: 'DriversPageAdmin', component: Drivers, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/passengers', name: 'PassengersPageAdmin', component: Passengers, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/companies', name: 'CompaniesPageAdmin', component: Companies, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/orderArchive', name: 'OrderArchivePageAdmin', component: OrderArchive, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/stations', name: 'StationsPageAdmin', component: Station, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},

  { path: '/admin/hotels', name: 'HotelsPageAdmin', component: Hotel, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},

  { path: '/admin/dispatchers', name: 'DispatchersPageAdmin', component: Dispatcher, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/payoff', name: 'PayoffPageAdmin', component: Payoff, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/settings', name: 'SettingsPageAdmin', component: Settings, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/company/:id', name: 'CompanyProfileAdmin', component: CompanyProfile, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/driver/:id', name: 'DriverProfileAdmin', component: DriverProfile, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/order/:id', name: 'OrderProfileAdmin', component: OrderProfile, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/passenger/:id', name: 'PassengerProfileAdmin', component: PassengerProfile, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/payoff/:id', name: 'PayoffProfileAdmin', component: PayoffProfile, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/payoffCompany/:id', name: 'PayoffCompanyProfileAdmin', component: PayoffCompany, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/profile/orderCompany/:id', name: 'OrderCompanyProfileAdmin', component: OrderProfileCompany, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/invoices/:id', name: 'InvoicesAdmin', component: Invoices, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/dispatcher/profile/:id', name: 'DispatcherProfileAdmin', component: DispatcherProfile, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  // { path: '/admin/map', name: 'DashboardMap', component: FleetMap, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},

  { path: '/admin/companies/archive', name: 'CompaniesArchivePageAdmin', component: CompanyArchive, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/admin/drivers/archive', name: 'DriversArchivePageAdmin', component: DriverArchive, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},

  { path: '/dispatcher/dashboard', name: 'DashboardPageDispatcher', component: Dashboard, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/orders', name: 'OrdersPageDispatcher', component: Orders, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/drivers',  name: 'DriversPageDispatcher',component: Drivers,meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/passengers', name: 'PassengersPageDispatcher', component: Passengers, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/companies', name: 'CompaniesPageDispatcher', component: Companies, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/orderArchive', name: 'OrderArchivePageDispatcher', component: OrderArchive, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/stations', name: 'StationsPageDispatcher', component: Station, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},

  { path: '/dispatcher/hotels', name: 'HotelsPageDispatcher', component: Hotel, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},

  { path: '/dispatcher/payoff', name: 'PayoffPageDispatcher', component: Payoff, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/dispatchers', name: 'DispatchersPageDispatcher', component: Dispatcher, meta: { requiresAuth: true, role: 'ROLE_ADULT_DISPATCHER' }},
  { path: '/dispatcher/settings', name: 'SettingsPageDispatcher', component: Settings, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/company/:id', name: 'CompanyProfileDispatcher', component: CompanyProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/driver/:id', name: 'DriverProfileDispatcher', component: DriverProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/order/:id', name: 'OrderProfileDispatcher', component: OrderProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/passenger/:id', name: 'PassengerProfileDispatcher', component: PassengerProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/payoff/:id', name: 'PayoffProfileDispatcher', component: PayoffProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/payoffCompany/:id', name: 'PayoffCompanyProfileDispatcher', component: PayoffCompany, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/orderCompany/:id', name: 'OrderCompanyProfileDispatcher', component: OrderProfileCompany, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/invoices/:id', name: 'InvoicesDispatcher', component: Invoices, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'] }},
  { path: '/dispatcher/profile/:id', name: 'DispatcherProfileDispatcher', component: DispatcherProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER', 'ROLE_ADMIN'] }},

  { path: '/dispatcher/companies/archive', name: 'CompaniesArchivePageDispatcher', component: CompanyArchive, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},
  { path: '/dispatcher/drivers/archive', name: 'DriversArchivePageDispatcher', component: DriverArchive, meta: { requiresAuth: true, role: 'ROLE_ADMIN' }},

  { path: '/driver/dashboard', name: 'DashboardPageDriver', component: DashboardDriver, meta: { requiresAuth: true, role: 'ROLE_DRIVER' }},
  { path: '/driver/payoff', name: 'PayoffPageDriver', component: PayoffDriver, meta: { requiresAuth: true, role: 'ROLE_DRIVER' }},
  { path: '/driver/chat', name: 'ChatPageDriver', component: ChatDriver, meta: { requiresAuth: true, role: 'ROLE_DRIVER' }},
  { path: '/driver/settings', name: 'SettingsPageDriver', component: Settings, meta: { requiresAuth: true, role: 'ROLE_DRIVER' }},
  // { path: '/driver/orders', name: 'OrdersPageDriver', component: Orders, meta: { requiresAuth: true, role: 'ROLE_DRIVER' }},

  // { path: '/admin/profile/:id', name: 'DispatcherProfile', component: DispatcherProfile, meta: { requiresAuth: true, role: ['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER', 'ROLE_ADMIN'] }},

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    beforeEnter: (to, from, next) => {
      const authStore = useAuthStore();
      if (authStore.isAuthenticated) {
        if (authStore.user.role === 'ROLE_ADMIN' && to.path !== '/admin/dashboard') {
          next('/admin/dashboard');
        } else if (['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'].includes(authStore.user.role) && to.path !== '/dispatcher/dashboard') {
          next('/dispatcher/dashboard');
        } else if ('ROLE_DRIVER'.includes(authStore.user.role) && to.path !== '/dispatcher/orders') {
          next('/driver/dashboard')
        } else {
          next();
        }
      } else {
        next('/login');
      }
    }
  }   
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login');
  } 

  if (to.meta.requiresAuth && to.meta.role) {
    const allowedRoles = Array.isArray(to.meta.role) ? to.meta.role : [to.meta.role];
    
    if (!allowedRoles.includes(authStore.user.role)) {
      if (authStore.user.role === 'ROLE_ADMIN' && to.path !== '/admin/orders') {
        next('/admin/orders');
      } else if (['ROLE_YOUNG_DISPATCHER', 'ROLE_ADULT_DISPATCHER'].includes(authStore.user.role) && to.path !== '/dispatcher/orders') {
        next('/dispatcher/orders');
      } else if ('ROLE_DRIVER'.includes(authStore.user.role) && to.path !== '/dispatcher/orders') {
        next('/driver/dashboard')
      } else {
        next();
      }
    } else {
      next();
    }
  } 
  else {
    next();
  }
});


export default router;
